import React from "react"
import { Route } from "react-router-dom"

import { useAssertRootQueryLoaded } from "graphql/smart-queries/user"
import { useMutationLoadingStatus } from "shared/context/mutation-loading-status"
import Wayfinder from "shared/wayfinder"
import { RouteProps } from "./types"

export const GuestRoute = ({ component: Component, ...props }: RouteProps) => {
  const { user } = useAssertRootQueryLoaded()
  const { isLoading } = useMutationLoadingStatus()

  const isUser = user && user.active

  return (
    <Route
      {...props}
      render={routeProps => {
        if (!isUser || isLoading) {
          return <Component {...routeProps} />
        }

        return <Wayfinder />
      }}
    />
  )
}
